<template>
    <div>
        <div class="month">
           <table class="table table-striped  limit table-responsive-xl">
                <thead>
                <tr>
                    <th>Дата</th>
                    <th>Вид зайнятості</th>
                    <th>Організація</th>
                    <th>Підрозділ</th>
                    <th>Посада</th>
                    <th>Документ</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="item of profile">
                    <td>{{item.Date}}</td>
                    <td>{{item.type}}</td>
                    <td>{{item.Org}}</td>
                    <td>{{item.Pidrozdil}}</td>
                    <td>{{item.Posada}}</td>
                    <td>{{item.doc+' '+item.docNumber+' від '+item.docTime}}</td>
                </tr>

                </tbody>
            </table>
        </div>

        <div class="d-flex flex-row align-items-center p-2">
            <div class="icon-stack display-3 flex-shrink-0">
                <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                <i class="fas fa-address-book icon-stack-1x opacity-100 color-primary-500"></i>
            </div>
            <div class="ml-3">
                <strong>
                    Код BAF
                </strong>
                <br>
                {{profileactual.code1C}}
            </div>
        </div>

        <div class="d-flex flex-row align-items-center p-2">
            <div class="icon-stack display-3 flex-shrink-0">
                <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                <i class="fal fa-address-book icon-stack-1x opacity-100 color-primary-500"></i>
            </div>
            <div class="ml-3">
                <strong>
                    Дата народження
                </strong>
                <br>
                {{profileactual.birthday}}
            </div>
        </div>
        <div class="d-flex flex-row align-items-center p-2">
            <div class="icon-stack display-3 flex-shrink-0">
                <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                <i class="fal fa-address-book icon-stack-1x opacity-100 color-primary-500"></i>
            </div>
            <div class="ml-3">
                <strong>
                    Місце народження
                </strong>
                <br>
                {{profileactual.place}}
            </div>
        </div>



   </div>
</template>

<script>
    export default {
        name: "profile1c",
		props: {
			user: {
				type: Object,
			},
			user_id: {
				type: Number,
				default: 0,
			}
		},

        data() {
            return  {
                profile: [],
            }
        },

        created() {
			this.getUserData();
        },

        methods : {
            async getUserData () {
				await api.get('/user/' + this.user_id + "/1c_data").then(({data}) => {
					if(data.status === "operation_success") {
						this.profile = data.data;
					}
				}).catch(err => {
					console.log(err);
				});
			},
        },
		computed: {
			profileactual: function () {
				let prof = {
					code1C		: '',
					birthday	: '',
					place		: ''
				};

				if (this.profile.length >0) {
					prof.code1C = this.profile[this.profile.length - 1].code1C;
					prof.birthday = this.profile[this.profile.length - 1].birthday;
					prof.place = this.profile[this.profile.length - 1].place;
				}
				return prof;
			}
		},
    }
</script>

<style scope>
    .name_at {
        font-family: Roboto Bold;
        font-weight: bolder;
    }
</style>
